import React from "react"

import * as courseTimetable from "../styles/CourseTimetable.module.css"

import { ChildSelector } from "../helpers/ChildSelector"

export default function CourseTimetable(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `timetable-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "timetable-date")
    .map(t => t.text)

  const cta = content.childNodes.filter(node =>
    node.classNames.trim().split(/\s+/).includes("timetable-cta")
  )[0]

  return (
    <>
      <div className={`row ${courseTimetable.wrapper}`}>
        <div className={`col-12 ${courseTimetable.holder}`}>
          <h1 className={`${courseTimetable.title}`}>{title}</h1>
          <hr className={`${courseTimetable.divider}`}/>
          {textStack.map((text, idx) => (
          <p key={idx} className={`${courseTimetable.text}`}>
            {text}
          </p>
        ))}
        {cta && (
          <div
          className={`${courseTimetable.cta}`}
          dangerouslySetInnerHTML={{
            __html: cta,
          }}
        />
        )}
        </div>
      </div>
    </>
  )
}
